<template>
  <div>
    <mobile-page v-if="isMobile"></mobile-page>
    <web-page v-else></web-page>
  </div>
</template>

<script>
import MobilePage from './MobilePage'
import WebPage from './WebPage'
import '../assets/base.css'
let isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)

export default {
  name: 'MainPage',
  components: {
    MobilePage,
    WebPage
  },
  data () {
    return {
      isMobile
    }
  },
  beforeCreate () {
    // 解决IOS微信webview后退不执行JS的问题
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MainPage.vue?fd781f4c